module.exports = __webpack_public_path__ + "img/30.6a369b27.jpg";